import { SnackbarProvider } from "notistack";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";


// INCLUDE ALL THIRD PARTY LIBRARY CSS FILES
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";

// MAIN ROOT ELEMENT
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<BrowserRouter>
		<SnackbarProvider anchorOrigin={{ horizontal: "right", vertical: "top" }}>
			<App />
		</SnackbarProvider>
	</BrowserRouter>
);
